.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  user-select: none;
}

.plantSelect {
  --slide-distance: 150%;
  composes: slideLeft from global;
}
